export default function FloatingButtons() {
  return null;
}
